<template>
    <div v-if="hasLoadedActivity">
        <h2 class="text-xl flex items-center mb-8"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Úprava aktivity #{{ $route.params.id }}</h2>
    
        <md-dialog-alert
            :md-active.sync="saved"
            md-title="Záznam bol upravený"
            :md-content="`Záznam bol úspešne upravený`" />
    
        <md-dialog-confirm
            :md-active.sync="active"
            md-title="Ste si istý ?"
            :md-content="`Chcete uložiť záznam</strong> ?`"
            md-confirm-text="Potvrdiť"
            md-cancel-text="Zrušiť"
            @md-confirm="saveClient" />
        
        <div class="flex flex-wrap w-full -mx-4">
            <div class="w-1/2 px-4">
                <div class="flex flex-wrap -mx-4">
                
                    <div class="w-1/2 px-4">
                        <md-field>
<!--                            <label>Štart</label>-->
                            <datetime
                                type="datetime"
                                v-model="fromDate"
                                :hour-step="1"
                                :minute-step="1"
                                placeholder="Štart"
                                title="Štart"
                                :format="dateFormat" :auto="true" input-class="md-input">
                                <template slot="button-cancel">
                                    <md-button class="md-dense md-primary">
                                        Zrušiť
                                    </md-button>
                                </template>
                                <template slot="button-confirm">
                                    <md-button class="md-dense md-primary">
                                        OK
                                    </md-button>
                                </template>
                            </datetime>
                        </md-field>
                    </div>
                    <div class="w-1/2 px-4">
                        <md-field>
                            <datetime
                                type="datetime"
                                v-model="toDate"
                                :hour-step="1"
                                :minute-step="1"
                                placeholder="Koniec"
                                title="Koniec"
                                :format="dateFormat" :auto="true" input-class="md-input">
                                <template slot="button-cancel">
                                    <md-button class="md-dense md-primary">
                                        Zrušiť
                                    </md-button>
                                </template>
                                <template slot="button-confirm">
                                    <md-button class="md-dense md-primary">
                                        OK
                                    </md-button>
                                </template>
                            </datetime>
                        </md-field>
                    </div>
                
                    <div class="w-full px-4">
                        <md-field>
                            <label>Popis</label>
                            <md-input v-model="activity.note" md-counter="255"></md-input>
                        </md-field>
                    </div>
                    <div class="w-full px-4">
                        <md-checkbox v-model="activity.fixing">Oprava</md-checkbox>
                    </div> <div class="w-full px-4">
                        <md-checkbox v-model="activity.invoiced">Fakturované</md-checkbox>
                    </div>
            
                </div>
            </div>
            
        </div>
    
        <div class="justify-start flex">
            <md-button @click="() => this.active = true" class="md-raised md-primary text-white">Uložiť</md-button>
            <md-button :to="{name: 'activities.list', params: {group: 'by_project'}}">Späť na zoznam</md-button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ActivityEdit",
        
        data: () => ({
            active: false,
            saved: false,
            dateFormat: "yyyy-MM-dd HH:mm:ss",
            fromDate:null,
            toDate: null,
        }),
        
        computed: {
            ...mapState({
                activity: state => state.activity.activity,
            }),

            hasLoadedActivity() {
                return Object.keys(this.activity).length > 0;
            }
        },
        
        methods: {
            saveClient() {
                this.activity.start_time = this.fromDate;
                this.activity.end_time = this.toDate;
                this.$store.dispatch("saveActivity", this.activity)
                    .then(() => {
                        this.saved = true;
                    })
            },
        },
        
        mounted() {
            this.$store.dispatch("fetchActivity", {
                id: this.$route.params.id
            }).then(() => {
                if(this.activity.error) {
                    console.error(this.activity.error);
                    return;
                }
                this.fromDate = moment(this.activity.start_time).toISOString();
                this.toDate = moment(this.activity.end_time).toISOString();
            })
        }
    }
</script>

<style lang="scss">
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        @apply bg-orange-500;
    }
    
    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button {
        @apply text-orange-500;
    }
    
    .vdatetime-popup__actions__button {
        @apply p-0;
    }
    
    .vdatetime-popup__actions {
        @apply px-0 pb-3 pt-2;
    }
</style>